module.exports = {
  footerText: 'BIRO QHSE & SM © 2021  | QHSE PASS VER 0',
}
